import { render, staticRenderFns } from "./RequestModal.vue?vue&type=template&id=d04e2f60&"
import script from "./RequestModal.vue?vue&type=script&lang=js&"
export * from "./RequestModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports